import React, { useEffect, useState, Component, useContext } from 'react';
import Services, { URI } from '../services/service';
import service from '../services/service';
import "./CourseSection.css";
import UserService from '../services/UserService';
import CryptoJS from "crypto-js";
import { useHistory } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Carousel from 'react-grid-carousel';
import { Rating } from 'react-simple-star-rating';
import { FaStar } from "react-icons/fa";
import moment from 'moment';


export default function CourseSectionCD({ currentCourseId, handleCourseClick, courseCatagory }) {

  const [getAvgRating, setAvgRating] = useState([]);
  const [courseState, setCourseState] = useState([]);
  const [rating, setRating] = useState([]);
  const history = useHistory();

  const CourseDetails = (id, tid, status) => {

    //console.log(id, tid);

    const secretKey = "cdac@123"

    const encodedCourseId = CryptoJS.AES.encrypt(
      `${id}`,
      secretKey
    ).toString();
    const safeEncodedCourseId = encodedCourseId
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");

    const encodedTenantId = CryptoJS.AES.encrypt(
      `${tid}`,
      secretKey
    ).toString();
    const safeEncodedTenantId = encodedTenantId
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");

    history.push(`${process.env.PUBLIC_URL + "/course-details/"}${safeEncodedCourseId}/${safeEncodedTenantId}/${status}`);

    let courseStatus = true;

    handleCourseClick(courseStatus);
  }

  useEffect(() => {
    const fetchPosts = async () => {
      const res = await service.getAllCourses();
      // console.log("res ==== ", res.data)
      setCourseState(res.data);
    };
    fetchPosts();
  }, []);

  useEffect(() => {
    ratingTest();

  }, [courseState])

  const ratingTest = () => {

    courseState.map((data, i) => {
      ////console.log(data.courseId);
      setRating(rating => [...rating, { itemId: data.courseId, reviewType: 1, tenantId: 1 }])
    })
  }
  useEffect(() => {
    ////console.log("108" + rating);
    if (rating !== " ") {
      //console.log("rating ", rating);
      Services.averageRating(rating)
        .then(res => {
          setAvgRating(res?.data);
        })
    }
  }, [rating]);

  const imageUrls = (url) => {
    if (url == null) {
      return '';
    } else {
      let imagepath = url.replace(/\\/g, "\\\\");
      let imageurl = `${URI.SERVER?._COURSE_URL}/${imagepath}`;
      return imageurl;
    }

  }

  const handleContentDependOnDate = (closingDate) => {

    const dateLimit = moment(closingDate);
    const now = moment();

    if (dateLimit.isValid() && dateLimit > now) {

      return true
    }
  };


  return (
    <div className="courses-container">
      <h2 className="courses-heading">
        <span>Not the right fit for you? </span>
      </h2>
      <p className='sub-head-text'>Expore more in-demand certificate program</p>
      <Carousel
        cols={4}
        rows={1}
        gap={10}
        loop
        showDots
        autoplay={3000}
        containerStyle={{ padding: "20px" }}
        responsiveLayout={[
          {
            breakpoint: 1400, // below 1200px
            cols: 3,
          },
          {
            breakpoint: 992, // below 992px
            cols: 2,
          },
          {
            breakpoint: 768, // below 768px (mobile)
            cols: 1,
          },
        ]}
        mobileBreakpoint={768} // switches to mobile mode below 768px
      >
        {courseState.map((course) => (
          course.status == 'P'? ((currentCourseId != course.courseId && (courseCatagory == course.catName || courseCatagory == undefined)) && (<Carousel.Item key={course.courseId} >
            <div key={course.courseId} className="course-card">
              <div className="course-image-cd">
                <img src={imageUrls(course.courseImage)} alt={course.courseName} />
                <span className="badge">Fully Self-Paced Learning</span>
              </div>

              <div className="course-content-cs">
                <h3 className="course-title">{course.courseName}</h3>
                <h4 className="course-category">Category: {course.catName}</h4>
                <div className="course-meta">
                  <span><i class="fa fa-clock-o" aria-hidden="true"></i> {course.duration} Days</span>
                  <div className="rating">
                    <ul className="list-unstyled list-inline">
                      {(() => {
                        const matchedRating = getAvgRating.find(
                          (d) => course.courseId.toString() === d.itemId
                        );

                        if (matchedRating && matchedRating.avgScore > 0) {
                          // Matching rating found → yellow star
                          return (
                            <li className="rating-item">
                              <FaStar color="#FFD700" size={16} style={{ marginRight: "4px" }} />
                              {matchedRating.avgScore}
                            </li>
                          );
                        } else {
                          // No rating found → gray star
                          return (
                            <li className="rating-item">
                              <FaStar color="#c7c7c7ff" size={16} style={{ marginRight: "4px" }} />
                              0
                            </li>
                          );
                        }
                      })()}
                    </ul>
                  </div>
                  {course.courseType == "free" ? <><i class='fas fa-money-check'></i>Free </> : <><div className="fees"><i class='fas fa-money-check'></i> ₹{course.fees} <br /> ${course.courseForeignFees}</div></>}
                </div>
              </div>

              <div className="course-footer">
                {handleContentDependOnDate(course.closingDate) ? <button className="enroll-btn-new" onClick={() => CourseDetails(course.courseId, 1, course.status)} >Enroll Now</button> : <button className="enroll-btn-closed" onClick={() => CourseDetails(course.courseId, 1, course.status)}>Course Closed</button>}
              </div>
            </div>
          </Carousel.Item>)):<></>
        ))}
      </Carousel>
    </div>
  );
}
